import { render, staticRenderFns } from "./LastYearConference.vue?vue&type=template&id=fa721d48&scoped=true&"
import script from "./LastYearConference.vue?vue&type=script&lang=js&"
export * from "./LastYearConference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa721d48",
  null
  
)

export default component.exports